<template>
  <div>
    <tabs v-if="user.tabsEnabled" @TabChange="onTabChange" centered position="bottom" type="neutral" tab-nav-wrapper-classes="card-header-nav icon" tab-content-classes="tab-content-padding tab-no-space " v-model="activeTab">
      <!-- Waiting Room -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.waitingRoom" label="waiting-room">
        <template slot="label">
          <i class="fa fa-clinic-medical" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'waiting-room',
          })
            "></i>
        </template>
        <div style="height: 100%">
          <div v-if="appointments && appointments.length > 0" class="pb-4">
            <div class="col-lg-12 col-md-12 col-sm-12" v-for="appointment in appointments" :key="appointment._id">
              <card class="card-stats">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">
                    <div v-if="appointment.referenceId" class="row appointment-id justify-content-end pr-4">
                      <div class="" style="font-size: small; font-weight: 600;">
                        <span style="margin-right: 0.5em">
                          <i class="fas fa-hashtag"></i>
                        </span>
                        <span>{{ appointment.referenceId }}</span>
                      </div>
                    </div>
                    <div class="row visit-details details">
                      <div class="col-3 col-md-4 pr-0">
                        <div class="row">
                          <div class="col-12 text-center">
                            <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-center">
                            <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                              <span>
                                <i class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="appointment.patient.gender == 'female'
                              " style="color: rgb(235, 63, 157)">
                              <span>
                                <i class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="appointment.patient.gender == 'others'
                              " style="color: rgb(33, 243, 208)">
                              <span>
                                <i class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-9 col-md-8 right">
                        <slot>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-calendar-check"></i>
                              </span>
                            </div>
                            <div class="col-md-6 col-6 pl-0">
                              <span>{{
                                getConsultationType(
                                  appointment.consultationType, appointment.appointmentType
                                )
                              }}</span>
                            </div>
                            <div v-if="unreadMessagesCount(appointment) > 0 && chatMode(appointment)" style="position: absolute;right: 1em;display: flex;justify-content: center;align-items: start;">
                              <span style="color: white;position: absolute;font-size: 0.7em;margin-top: 0.4em;">
                                {{ unreadMessagesCount(appointment) }}
                              </span>
                              <span>
                                <i class="far fa-comment-alt" style="font-weight: 900;color: var(--color-primary);font-size: 2em;"></i>
                              </span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.firstName">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ appointment.patient.firstName }}
                                {{ appointment.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.patientId">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-info-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-10 col-9 pl-0">
                              <span>{{
                                appointment.patient.patientId
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.dob">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-birthday-cake"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                getAge(appointment.patient.dob)
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.mobileNumber">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-mobile"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                appointment.patient.mobileNumber
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.reason">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-question"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ appointment.reason }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.appointmentType == 'Scheduled'
                            ">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-clock-o"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                getAppointmentDatetime(
                                  appointment.scheduledTimestamp.start
                                )
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.appointmentType == 'Discussion'
                              ">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user-md"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span v-if="appointment.specialityText">{{
                                appointment.specialityText
                              }}</span>
                              <span v-if="appointment.provider">{{
                                $t('message.Dr') + ' . ' + appointment.provider.firstName + ' ' +
                                appointment.provider.lastName
                              }}</span>
                            </div>
                          </div>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="stats text-center" slot="footer">
                  <n-button v-if="appointment.latestStatus == 'Assigned' || appointment.consultationType == 'inperson'" type="primary" class="btn-padding light mr-2" simple round @click.native="cancelAppointment(appointment)">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                    {{ $t("message.Cancel") }}
                  </n-button>
                  <n-button type="primary" class="btn-padding light mr-2" round @click.native="joinAppointment(appointment)" v-if="appointment.latestStatus != 'Completed' &&
                    (appointment.appointmentType != 'Scheduled' ||
                      (appointment.appointmentType == 'Scheduled' &&
                        (appointment.latestStatus == 'Assigned' ||
                          appointment.latestStatus == 'InProgress')))
                    ">
                    <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                    {{ $t("message.Join") }}
                  </n-button>
                  <n-button type="primary" class="btn-padding light mr-2" round simple @click.native="viewAppointmentDetails(appointment)" v-if="appointment.latestStatus != 'Assigned' &&
                    appointment.latestStatus != 'InProgress'
                    ">
                    <i slot="label" class="fa fa-eye"></i>
                    {{ $t("message.View") }}
                  </n-button>
                </div>
              </card>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="position:relative;height:100%" v-if="!appointments || appointments.length < 1">
            <div>
              <i>{{ $t("message.Queued up visits will be shown here Click on new appointment to create an visit") }}</i>
            </div>
            <n-button type="primary" round size="lg" @click.native="goToCreateAppointmentPage()" id="main-create-appt-button">
              <i class="fa fa-plus pr-1"></i>
              {{ $t("message.New Appointment") }}
            </n-button>
            <queue-svg id="queue-svg"></queue-svg>
          </div>
        </div>
        <n-button v-if="appointments && appointments.length > 0" type="primary" round size="lg" @click.native="goToCreateAppointmentPage()
          " style="
                  top: auto;
                  bottom: 4em;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                  width: 15em;
                ">
          <i class="fa fa-plus pr-1"></i>
          {{ $t("message.New Appointment") }}
        </n-button>
      </tab-pane>

      <!-- quick discussion tab -->
      <tab-pane v-if="user.tabsEnabled &&
        settings.quickDiscussionAppointmentsEnabled" label="quick-discussion">
        <template slot="label">
          <i class="fa fa-comment-medical" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'quick-discussion',
          })
            "></i>
        </template>
        <div style="height: 100%">
          <div v-if="discussionAppointments && discussionAppointments.length > 0" class="pb-4">
            <div class="col-lg-12 col-md-12 col-sm-12" v-for="appointment in discussionAppointments" :key="appointment._id">
              <div class="card-stats" v-if="appointment.appointmentType == 'Discussion'" style="text-align: center;">
                <div class="col-12 text-center" style="display: flex;justify-content: center;align-items: center;margin-bottom: 3em;">
                  <div class="la-ball-scale-multiple" style="
                margin-bottom: 1rem;
                  color: var(--green);
                ">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <p style="font-size: 1.2rem;font-weight: 600;padding-right: 32px;">Appointment in progress</p>
                </div>
                <div class="statistics statistics-horizontal" style="margin-bottom: 3em;">
                  <div class="info info-horizontal">
                    <div v-if="appointment.referenceId" class="row appointment-id justify-content-end pr-4">
                      <div class="" style="font-size: small; font-weight: 600;">
                        <span style="margin-right: 0.5em">
                          <i class="fas fa-hashtag"></i>
                        </span>
                        <span>{{ appointment.referenceId }}</span>
                      </div>
                    </div>
                    <div class="visit-details details" style="display: flex;flex-direction: column;align-items: center;">
                      <div class="col-3 col-md-4 pr-0">
                        <div class="row">
                          <div class="col-12 text-center">
                            <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-center" v-if="appointment.patient">
                            <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                              <span>
                                <i class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="appointment.patient.gender == 'female'
                              " style="color: rgb(235, 63, 157)">
                              <span>
                                <i class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="appointment.patient.gender == 'others'
                              " style="color: rgb(33, 243, 208)">
                              <span>
                                <i class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-9 col-md-8 right">
                        <slot>
                          <div class="row">
                            <div v-if="unreadMessagesCount(appointment) > 0 && chatMode(appointment)" style="position: absolute;right: 1em;display: flex;justify-content: center;align-items: start;">
                              <span style="color: white;position: absolute;font-size: 0.7em;margin-top: 0.4em;">
                                {{ unreadMessagesCount(appointment) }}
                              </span>
                              <span>
                                <i class="far fa-comment-alt" style="font-weight: 900;color: var(--color-primary);font-size: 2em;"></i>
                              </span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.firstName">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ appointment.patient.firstName }}
                                {{ appointment.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.patientId">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-info-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-10 col-9 pl-0">
                              <span>{{
                                appointment.patient.patientId
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.dob">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-birthday-cake"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                getAge(appointment.patient.dob)
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.patient && appointment.patient.mobileNumber">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-mobile"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                appointment.patient.mobileNumber
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.reason">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-question"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ appointment.reason }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.appointmentType == 'Scheduled'
                            ">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-clock-o"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                getAppointmentDatetime(
                                  appointment.scheduledTimestamp.start
                                )
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="appointment.appointmentType == 'Discussion'
                              ">

                            <div class="col-md-12" style="text-align: center;">
                              <span v-if="appointment.specialityText">{{
                                appointment.specialityText
                              }}</span>
                              <span style="font-size: 1rem; font-weight: 600;" v-if="appointment.provider">{{
                                $t('message.Dr') + ' . ' + appointment.provider.firstName + ' ' +
                                appointment.provider.lastName
                              }}</span>
                            </div>
                          </div>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
                <appointment-in-progress></appointment-in-progress>
                <div class="col-12 text-center">
                  <p style="margin-top: 3em;font-size: 12px">*Cancel this to create new appointment</p>
                </div>
                <div class="stats text-center" style="display: flex;margin-top: 5em;justify-content: space-evenly;">
                  <n-button size="lg" v-if="!['Closed', 'Completed', 'Postponed'].includes(appointment.latestStatus)" type="primary" class="btn-padding light mr-2" simple round @click.native="cancelAppointment(appointment)">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                    {{ $t("message.Cancel") }}
                  </n-button>
                  <n-button size="lg" type="primary" class="btn-padding light mr-2" round @click.native="joinDiscussionAppointment(appointment)" v-if="appointment.latestStatus != 'Completed' &&
                    (appointment.appointmentType != 'Scheduled' ||
                      (appointment.appointmentType == 'Scheduled' &&
                        (appointment.latestStatus == 'Assigned' ||
                          appointment.latestStatus == 'InProgress')))
                    ">
                    <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                    {{ $t("message.Join") }}
                  </n-button>
                  <n-button type="primary" class="btn-padding light mr-2" round simple @click.native="viewAppointmentDetails(appointment)" v-if="appointment.latestStatus != 'Assigned' &&
                    appointment.latestStatus != 'InProgress'
                    ">
                    <i slot="label" class="fa fa-eye"></i>
                    {{ $t("message.View") }}
                  </n-button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="position:relative;height:100%" v-if="!discussionAppointments || discussionAppointments.length < 1">
            <div>
              <i>{{ $t("message.Queued up visits will be shown here Click on new appointment to create an visit") }}</i>
            </div>
            <queue-svg id="queue-svg"></queue-svg>
          </div>
        </div>

        <n-button v-if="settings.quickDiscussionAppointmentsEnabled && discussionAppointments && discussionAppointments.length < 1" type="primary" round size="lg" @click.native="goToCreateQuickDiscussionPage()
          " id="main-create-discussion-button" style="
                  top: auto;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                  width: 15em;
                ">
          <i class="fa fa-user-md pr-1"></i>
          {{ $t("message.Start a quick call") }}
        </n-button>
      </tab-pane>

      <!-- Scheduled Appointments -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.scheduledAppointments" label="scheduled-appts">
        <template slot="label">
          <i class="fa fa-calendar" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'scheduled-appts',
          })
            "></i>
        </template>
        <div style="height:calc(100% - 48px)">
          <div class=" col-12" style="text-align: center;">
            <div class="view-filters-wrapper">
              <div :class="scheduledApptDateFilter ? 'scheduled-appts-date-filter close-icon col-8' : 'col-8 scheduled-appts-date-filter'">
                <el-date-picker placeholder='Select date' v-model="scheduledApptDateFilter" format="dd-MM-yyyy" type="date" align="center" :picker-options="{}" :editable="false"></el-date-picker>
              </div>

              <div class="">
                <n-button style="padding: 7px 15px;" type="primary" :class="scheduledApptPatientFilter ? ' mr-2' : 'btn-simple mr-2 '" round>
                  <span @click="openPatientFilterModal">

                    <i class="fas fa-user-injured"></i>
                    <span v-if="scheduledApptPatientFilter"> {{ scheduledApptPatientFilter.firstName }}
                      {{ scheduledApptPatientFilter.lastName }}
                    </span>
                    <span v-if="!scheduledApptPatientFilter"> Select Patient
                    </span>
                  </span>
                  <i v-if="scheduledApptPatientFilter" class="pl-2 now-ui-icons ui-1_simple-remove" @click="clearPatientFiltersForScheduledAppts"></i>
                  <!-- patient -->
                </n-button>

                <n-button style="padding: 7px 15px;" type="primary" :class="scheduledApptDoctorFilter ? ' mr-2' : 'btn-simple mr-2'" round>
                  <span @click="openDoctorFilterModal">
                    <i class="fas fa-user-md"></i>
                    <span v-if="scheduledApptDoctorFilter"> {{ scheduledApptDoctorFilter.firstName }}
                      {{ scheduledApptDoctorFilter.lastName }} </span>
                    <span v-if="!scheduledApptDoctorFilter"> Select Doctor </span>
                  </span>
                  <i v-if="scheduledApptDoctorFilter" class="pl-2 now-ui-icons ui-1_simple-remove" @click="clearDoctorFiltersForScheduledAppts"></i>
                  <!-- doctor -->
                </n-button>

              </div>

              <!-- <div class="">
                <n-button type="primary" class="btn-padding light" simple round @click.native="clearFiltersForScheduledAppts">
                  <i class="now-ui-icons ui-1_simple-remove"></i>

                </n-button>
              </div> -->

            </div>

          </div>

          <!-- below height is set so that the filters above dont scroll outside the view, because body height and wrapper height is removed -->
          <div class="col-12 pt-3" style="height: calc(100vh - 11em);overflow:scroll; padding-bottom:8em;" v-if="scheduledAppointments.length > 0">
            <div v-for="appointment in scheduledAppointments" :key="appointment._id">
              <appointment-details-card :appointment="appointment" @appointment-declined="getScheduledAppts()">
                <template slot="footer">
                  <div class="text-center scheduled-appointment-card">
                    <n-button type="primary" class="btn-padding light mr-2" simple round @click.native="deleteAppointment(appointment)" v-if="appointment.latestStatus != 'InProgress'">
                      <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                      {{ $t("message.Cancel") }}
                    </n-button>
                    <n-button type="primary" class="btn-padding light mr-2" simple round @click.native="openSlotSelection(appointment)" v-if="appointment.latestStatus != 'InProgress'">
                      <i class="fa fa-calendar" slot="label"></i>
                      {{ $t("message.Reschedule") }}
                    </n-button>
                    <n-button type="primary" class="btn-padding light mr-2" simple round @click.native="goToPatientManagementTab(appointment.patient.patientId)" v-if="appointment.latestStatus != 'InProgress'">
                      <i class="fa fa-pencil-alt" slot="label"></i>
                      {{ $t("message.Update") }}
                    </n-button>
                    <n-button type="primary" class="btn-padding light mr-2" round @click.native="showConsentIfEnabled(appointment)" v-if="appointment.consultationType != 'inperson'">
                      <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                      {{ $t("message.Join") }}
                    </n-button>
                  </div>
                </template>
              </appointment-details-card>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getScheduledAppts">
              <span slot="no-more">{{ $t("message.No more appointments") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>

          <modal :show.sync="SHOW_SLOT_SELECTION" headerclasses="justify-content-center">
            <h6 slot="header" class="title title-up">{{ $t('message.Select a slot') }}</h6>

            <slot-selection v-if="doctorForSlotSelection && SHOW_SLOT_SELECTION" :doctor-id="doctorForSlotSelection.providerId" @slot-selected="onSlotSelected"></slot-selection>
          </modal>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" style="position:relative;height:calc(100% - 40px);" v-if="!scheduledAppointments || scheduledAppointments.length < 1">
            <div>
              <i>{{ $t("message.No Appointments scheduled") }}</i>
            </div>
            <n-button id="create-scheduled-appt-button" type="primary" round size="lg" @click.native="goToCreateScheduledAppointmentPage()">
              <i class="now-ui-icons ui-1_calendar-60 pr-1"></i>
              {{ $t("message.Schedule Appointment") }}
            </n-button>
            <booking-svg id="booking-svg"></booking-svg>

          </div>
        </div>

        <modal :show.sync="SHOW_DOCTOR_FILTER_MODAL" headerclasses="justify-content-center">
          <h6 slot="header" class="title title-up">Search doctors</h6>

          <div class="filter-modal col-12">

            <div class="row">
              <div class="col-12">
                <fg-input :placeholder="'Search doctors'" :addon-right-icon="!doctorFilterSearchTextScheduledAppts
                  ? 'now-ui-icons ui-1_zoom-bold'
                  : 'now-ui-icons ui-1_simple-remove'
                  " type="text" v-model="doctorFilterSearchTextScheduledAppts" @keyup="searchDoctorsForScheduledApptsFilter()"></fg-input>

              </div>
            </div>

            <div class="filters-list-wrapper col-12">
              <div class="row search-result" v-for="doctor in searchedDoctorsForScheduledApptFilter" :key="doctor._id" @click="selectDoctorForScheduledApptsFilter(doctor)">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-2 pl-0 pr-0">
                      <profile-image v-if="doctor.profileImage" :file-id="doctor.profileImage" :image-style="'border-radius: 50%; vertical-align: middle; width: 50px; height: auto; aspect-ratio:1; border-radius: 50%; '"></profile-image>

                      <i class="fa fa-user-md text-center" v-if="!doctor.profileImage" style="background: #888; padding: 10px; border-radius: 50%; color: #fff; width: 50px; height: 50px; font-size: large;"></i>
                    </div>

                    <div class="col-10">
                      <div class="row">
                        <div class="col-8 pr-0">
                          <div style="margin-bottom:0px; text-transform: none; font-size: 16px; font-weight: 600" class="item-name">
                            {{ doctor.firstName }} {{ doctor.lastName }}
                          </div>
                          <div style="line-height:normal; font-size:12px;">{{ doctor.specialityText || "--" }}</div>
                        </div>

                        <div v-if="doctor.billingDetails && doctor.billingDetails.enabled && doctor.billingDetails.amount" style="font-weight: 700; display: flex; align-items: center;" class="col-3 pr-0">
                          <div>
                            <i :class="getCurrencyClass(doctor.billingDetails.currency)"></i>
                            {{ doctor.billingDetails.amount }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </modal>

        <modal :show.sync="SHOW_PATIENT_FILTER_MODAL" headerclasses="justify-content-center">
          <h6 slot="header" class="title title-up">Search Patient</h6>

          <div class="filter-modal col-12">

            <div class="row">
              <div class="col-12">
                <fg-input :placeholder="'Search patients'" :addon-right-icon="!patientFilterSearchTextScheduledAppts
                  ? 'now-ui-icons ui-1_zoom-bold'
                  : 'now-ui-icons ui-1_simple-remove'
                  " type="text" v-model="patientFilterSearchTextScheduledAppts" @keyup="searchPatientsForScheduledApptsFilter()"></fg-input>

              </div>
            </div>

            <div class="filters-list-wrapper col-12">
              <div class="row search-result" v-for="patient in searchedPatientsForScheduledApptFilter" :key="patient._id" @click="selectPatientForScheduledApptsFilter(patient)">
                <div class="col-12 ">
                  <div class="row">
                    <div class="col-2 pl-0 pr-0">
                      <profile-image v-if="patient.profileImage" :file-id="patient.profileImage" :image-style="'border-radius: 50%; vertical-align: middle; width: 50px; height: auto; aspect-ratio:1; border-radius: 50%; '"></profile-image>

                      <i class="fa fa-user-md text-center" v-if="!patient.profileImage" style="background: #888; padding: 10px; border-radius: 50%; color: #fff; width: 50px; height: 50px; font-size: large;"></i>
                    </div>

                    <div class="col-10">
                      <div class="row">
                        <div class="col-8 pr-0">
                          <div style="margin-bottom:0px; text-transform: none; font-size: 16px; font-weight: 600" class="item-name">
                            {{ patient.firstName }} {{ patient.lastName }}
                          </div>
                          <div style="line-height:normal; font-size:12px;">{{ patient.patientId || "--" }}</div>
                        </div>

                        <div v-if="patient.billingDetails && patient.billingDetails.enabled && patient.billingDetails.amount" style="font-weight: 700; display: flex; align-items: center;" class="col-3 pr-0">
                          <div>
                            <i :class="getCurrencyClass(patient.billingDetails.currency)"></i>
                            {{ patient.billingDetails.amount }}
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </modal>

        <!-- Informed consent modal-->
        <modal :show.sync="SHOW_CONSENT_MODAL" headerclasses="justify-content-center" :showClose="false">
          <template>
            <div class="col-12" style="height: 80vh; overflow: scroll" v-if="settings && SHOW_CONSENT_MODAL">
              <p v-html="settings.directTelemedicine.informedConsent"></p>
              <p>{{ $t("message.Signature of Patient") }}</p>
              <!-- width and height prop values should be in px, otherwise canvas won't show up -->
              <vue-signature style="border: solid;" ref="signature" :sigOption="signaturePadOptions" w="225px" h="140px" :disabled="false"></vue-signature>
            </div>
          </template>

          <template v-slot:footer>
            <n-button type="danger" round @click.native="SHOW_CONSENT_MODAL = false">
              <h6 class="m-0">{{ $t("message.Cancel") }}</h6>
            </n-button>
            <n-button type="danger" round @click.native="clearSignaturePad">
              <h6 class="m-0">
                {{ $t("message.Clear") }}
              </h6>
            </n-button>
            <n-button type="info" round @click.native="onConsentAgreed()">
              <h6 class="m-0">{{ $t("message.Agree") }}</h6>
            </n-button>
          </template>
        </modal>
        <n-button v-if="scheduledAppointments && scheduledAppointments.length > 0" type="primary" round size="lg" @click.native="goToCreateScheduledAppointmentPage()" style="
                  top: auto;
                  bottom: 4em;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                ">
          <i class="now-ui-icons ui-1_calendar-60"></i>
          {{ $t("message.Schedule Appointment") }}
        </n-button>
      </tab-pane>

      <!-- Completed Appointments -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.completedAppointments" label="completed-appts">
        <template slot="label">
          <i class="fa fa-history" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'completed-appts',
          })
            "></i>
        </template>
        <!-- below height is set so that the filters above dont scroll outside the view, because body height and wrapper height is removed -->
        <div style="height: calc(100vh - 9em)">
          <div class="row pb-1" style="display: flex;justify-content: center;">
            <div class="col-6" style="text-align:center;">
              <el-date-picker v-model="completedApptDateFilter" format="dd-MM-yyyy" type="date" :picker-options="{}" :editable="false"></el-date-picker>
            </div>
            <div class="col-4" style="text-align:center;">
              <checkbox v-on:input="changePostponedAppointmentValue()" :disabled="getCompletedAppointmentsExecuting">
                {{ $t("message.Postponed") }}
              </checkbox>
            </div>
          </div>
          <div class="col-12 pt-3" style="height: calc(100% - 40px);overflow:scroll;" v-if="completedAppointments.length > 0">
            <div class="h-100">
              <div v-for="appointment in completedAppointments" :key="appointment._id">
                <card class="card-stats">
                  <div class="statistics statistics-horizontal">
                    <div class="info info-horizontal">
                      <div v-if="appointment.referenceId" class="row appointment-id justify-content-end pr-4">
                        <div class="" style="font-size: small; font-weight: 600;">
                          <span style="margin-right: 0.5em">
                            <i class="fas fa-hashtag"></i>
                          </span>
                          <span>{{ appointment.referenceId }}</span>
                        </div>
                      </div>
                      <div class="row visit-details details">
                        <div class="col-3 col-md-4 pr-0">
                          <div class="row">
                            <div class="col-12 text-center">
                              <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                              <br />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12 text-center">
                              <div v-if="appointment.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                                <span>
                                  <i class="fa fa-mars"></i>
                                </span>
                              </div>
                              <div v-if="appointment.patient.gender == 'female'
                                " style="color: rgb(235, 63, 157)">
                                <span>
                                  <i class="fa fa-venus"></i>
                                </span>
                              </div>
                              <div v-if="appointment.patient.gender == 'others'
                                " style="color: rgb(33, 243, 208)">
                                <span>
                                  <i class="fa fa-transgender-alt"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-9 col-md-8 right">
                          <slot>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-user"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{ appointment.patient.firstName }}
                                  {{ appointment.patient.lastName }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-info-circle"></i>
                                </span>
                              </div>
                              <div class="col-md-10 col-9 pl-0">
                                <span>{{
                                  appointment.patient.patientId
                                }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-birthday-cake"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{
                                  getAge(appointment.patient.dob)
                                }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-mobile"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{
                                  appointment.patient.mobileNumber
                                }}</span>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-question"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{ appointment.reason }}</span>
                              </div>
                            </div>
                            <div class="row" v-if="appointment.appointmentType == 'Scheduled'
                              ">
                              <div class="col-md-1 col-3 text-center">
                                <span>
                                  <i class="fa fa-clock-o"></i>
                                </span>
                              </div>
                              <div class="col-md-8 col-9 pl-0">
                                <span>{{
                                  getAppointmentDatetime(
                                    appointment.scheduledTimestamp.start
                                  )
                                }}</span>
                              </div>
                            </div>
                          </slot>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="stats text-center" slot="footer">
                    <n-button type="primary" class="btn-padding light mr-2" round @click.native="viewAppointmentDetails(appointment)">
                      <i slot="label" class="fa fa-eye"></i>
                      {{ $t("message.View") }}
                    </n-button>
                    <n-button type="primary" v-if="appointment.discussionAppointmentId && appointment.prescriptionShared && !appointment.billingDetails.paid" class="btn-padding light mr-2" round @click.native="initiatePayment(appointment) && appointment.billingDetails.amount > 0">
                      <div style="display: flex;">
                        <span class="pr-2">{{ $t("message.PAY") }}</span>
                        <i :class="getCurrencyClass(appointment.billingDetails.currency)" style="padding-right: 0.2em;"></i>
                        <span>{{ appointment.billingDetails.amount }}</span>
                      </div>
                    </n-button>
                    <n-button type="primary" class="btn-padding light mr-2" simple round @click.native="viewRecording(appointment)" v-if="appointment.ucRecordings &&
                      appointment.ucRecordings.recordings.length > 0
                      ">
                      <i slot="label" class="fa fa-video"></i>
                      {{ $t("message.View Recording") }}
                    </n-button>
                  </div>
                </card>
              </div>
              <infinite-loading spinner="waveDots" @infinite="getCompletedAppointments">
                <span slot="no-more">{{ $t("message.No more appointments") }}</span>
                <span slot="no-results"></span>
              </infinite-loading>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!completedAppointments || completedAppointments.length < 1
            ">
            <i>{{ $t("message.No Appointments scheduled") }}</i>
            <booking-svg style="width: 100%; max-height: 50%;"></booking-svg>
          </div>
        </div>
      </tab-pane>

      <!-- Patients -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.patientManagement" label="patient-management">
        <template slot="label">
          <i class="fa fa-users" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'patient-management',
          })
            "></i>
        </template>
        <div class="row search-block">
          <div class="container">
            <div class="row">
              <div class="no-border col-12" @click="clearSearchText" style="text-align: center;">
                <fg-input :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :addon-right-icon="!searchText
                  ? 'now-ui-icons ui-1_zoom-bold'
                  : 'now-ui-icons ui-1_simple-remove'
                  " type="text" v-model="searchText" @keyup="searchPatient()"></fg-input>

                <h6 style="margin: 0px;" v-if="settings && settings.idCardScanner && settings.idCardScanner.enabled">{{
                  $t("message.OR") }}</h6>
                <n-button type="primary" round @click.native="SHOW_CAPTURE_MODAL = true" v-if="settings && settings.idCardScanner && settings.idCardScanner.enabled">
                  <h6 class="m-0"><i class="fa fa-camera" style="font-size: 1.3em;padding-right: 0.2em;"></i> Scan id card
                  </h6>
                </n-button>

              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="patients.length < 1" style="place-content: center;">
          <div class="col-12 text-center pb-4">
            <i v-if="searchText"> {{ $t('message.No patients found') }}</i>
          </div>
          <search-svg style="width:70vw; height: auto;"></search-svg>
        </div>

        <div class="row" style="margin: 0px;margin-bottom: 9em;">
          <patient-card v-for="patient in patients" :key="patient._id" :patient="patient"></patient-card>

          <!-- bottom: 4em to bring button into view-->
          <n-button type="primary" round size="lg" @click.native="$router.push({
            path: 'patients/create',
          })
            " style="
                    top: auto;
                    bottom: 4em;
                    left: 50%;
                    transform: translateX(-50%);
                    position: fixed;
                  ">
            <i class="fa fa-plus pr-1"></i>
            {{ $t("message.Create Patient") }}
          </n-button>
        </div>
        <app-camera-scanner :showCam="SHOW_CAPTURE_MODAL" ref="camera" @onClose="SHOW_CAPTURE_MODAL = false" @idFound="idFound" @notFound="idNotFound">
        </app-camera-scanner>
      </tab-pane>

      <!-- Service Requests -->
      <tab-pane v-if="settings &&
        settings.nurseCalling &&
        settings.nurseCalling.enabled
        " label="nurse-calling">
        <template slot="label">
          <i class="fa fa-user-nurse" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'nurse-calling',
          })
            "></i>
        </template>
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center" v-if="nurseCallingRequests.length < 1">
              <i> {{ $t("message.No services requested") }} </i>
            </div>
          </div>
          <div class="row" v-for="request in nurseCallingRequests" :key="request._id">
            <div class="col-12">
              <card @click.native="acceptNurseCallingRequest(request)">
                <div class="row">
                  <div class="col-3">
                    <dynamic-image :file-id="request.service.iconUrl"></dynamic-image>
                  </div>
                  <div class="col-7">
                    <h5>{{ request.service.name }}</h5>
                    <i>{{ request.service.description }}</i>
                    <br />
                    <i>{{ request.location.name }}</i>
                    <br />
                    <i class="text-info" v-if="request.latestStatus == 'InProgress'">{{ $t("message.In Progress") }} </i>
                  </div>
                  <div class="col-2">
                    <i class="fa fa-chevron-right" style="line-height: 60px" v-if="request.latestStatus != 'InProgress'"></i>
                    <i class="fa fa-check" style="line-height: 60px" v-if="request.latestStatus == 'InProgress'"></i>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-12">
          <n-pagination v-if="nurseCallingRequestsPagination.totalPages > 1" :page-count="nurseCallingRequestsPagination.totalPages" v-model="nurseCallingRequestsPagination.pageNumber"></n-pagination>
        </div>
      </tab-pane>

      <!-- Lab Orders -->
      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.labOrders" label="lab-orders">
        <template slot="label">
          <i class="fa fa-microscope" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'lab-orders',
          })
            "></i>
        </template>
        <div style="height: calc(100% - 48px);">
          <div class="pb-2">
            <div class="col-12 col-md-12 form-group">
              <div class="" @click="clearlabOrderSearchText">
                <fg-input :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :addon-right-icon="!labOrderSearchText ? 'now-ui-icons ui-1_zoom-bold' : 'now-ui-icons ui-1_simple-remove'" type="text" v-model="labOrderSearchText" @keyup="getLabOrders()"></fg-input>
              </div>
            </div>
            <div class="col-12 col-md-12 form-group">
              <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="latestStatusQuery">
                <el-option class="select-primary" value="" :label="$t('message.All Orders')"></el-option>
                <el-option class="select-primary" value="Created" :label="$t('message.Created Orders')"></el-option>
                <el-option class="select-primary" value="Accepted" :label="$t('message.Accepted Orders')"></el-option>
                <el-option class="select-primary" value="Sample Collected" :label="$t('message.Sample Collected ?')"></el-option>
                <el-option class="select-primary" value="Sample Deposited" :label="$t('message.Sample Deposited ?')"></el-option>
                <el-option class="select-primary" value="Report Uploaded" :label="$t('message.Fulfilled Orders')"></el-option>
              </el-select>
            </div>
          </div>

          <!-- below height is set so that the filters above dont scroll outside the view, because body height and wrapper height is removed -->
          <div v-if="laborders && laborders.length > 0" class="" style="height: calc(100vh - 15em);overflow: scroll; padding-bottom: 10em;">
            <div class="col-lg-12 col-md-12 col-sm-12" v-for="laborder in laborders" :key="laborder._id">
              <card class="card-stats">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">
                    <div v-if="laborder.referenceId" class="row appointment-id justify-content-end pr-4">
                      <div class="" style="font-size: small; font-weight: 600;">
                        <span style="margin-right: 0.5em">
                          <i class="fas fa-hashtag"></i>
                        </span>
                        <span>{{ laborder.referenceId }}</span>
                      </div>
                    </div>
                    <div class="row visit-details details">
                      <div class="col-3 col-md-4 pr-0">
                        <div class="row">
                          <div class="col-12 text-center">
                            <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-center">
                            <div v-if="laborder.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                              <span>
                                <i class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="laborder.patient.gender == 'female'" style="color: rgb(235, 63, 157)">
                              <span>
                                <i class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="laborder.patient.gender == 'others'" style="color: rgb(33, 243, 208)">
                              <span>
                                <i class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-9 col-md-8 right">
                        <slot>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ laborder.patient.firstName }}
                                {{ laborder.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-mobile"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ laborder.patient.mobileNumber }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-microscope"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ laborder.lab }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-clock"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ getLaborderDatetime(laborder.created) }}</span>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-question-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ getLabOrderStatus(laborder.latestStatus) }}</span>
                            </div>
                          </div>
                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="stats text-center" slot="footer">
                  <n-button type="primary" class="btn-padding light mr-2" round @click.native="viewLabOrderDetails(laborder)">
                    <i slot="label" class="fa fa-eye"></i>
                    {{ $t("message.View") }}
                  </n-button>
                </div>
              </card>
            </div>
            <infinite-loading spinner="waveDots" @infinite="getLabOrders">
              <span slot="no-more">{{ $t("message.No more lab orders") }}</span>
              <span slot="no-results"></span>
            </infinite-loading>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="!laborders || laborders.length < 1">
            <i>{{ $t("message.No lab orders") }}</i>
            <lab-order-svg></lab-order-svg>
          </div>
        </div>
        <n-button type="primary" round size="lg" @click.native="goToCreateLaborderPage()" style="
                  top: auto;
                  bottom: 4em;
                  left: 50%;
                  transform: translateX(-50%);
                  position: fixed;
                ">
          <i class="fa fa-plus pr-1"></i>
          {{ $t("message.New Laborder") }}
        </n-button>
      </tab-pane>

      <tab-pane v-if="user.tabsEnabled &&
        user.tabsEnabled.emergencyTriaging" label="emergency-triaging">
        <template slot="label">
          <i class="fas fa-hospital" @click="$store.commit('setState', {
            stateName: 'homePageActiveTab',
            stateValue: 'emergency-triaging',
          })
            "></i>
        </template>
        <div style="height: 100%">
          <div class="pb-2">

            <div class="col-12 col-md-12 form-group">
              <el-select class="select-primary" size="large" name="latestStatus" placeholder="Latest Status" v-model="latestERStatusQuery">
                <el-option class="select-primary" value="" :label="$t('message.All')"></el-option>
                <el-option class="select-primary" value="Created" :label="$t('message.Created')"></el-option>
                <el-option class="select-primary" value="InProgress" :label="$t('message.In Progress')"></el-option>
                <el-option class="select-primary" value="Completed" :label="$t('message.Completed')"></el-option>
              </el-select>
            </div>
          </div>
          <div class="col-12" v-if="!emergencyRoomEncounters || emergencyRoomEncounters.length == 0" style="text-align:center">
            No live encounters at this moment
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="emergencyRoomEncounters && emergencyRoomEncounters.length > 0" style="padding-bottom: 8em;">
            <!-- <div>
              <i>{{ $t("message.New Encounter") }}</i>
            </div> -->
            <div style=" height: 100%;overflow:scroll">
              <er-appointment-details-card :appointment="appt" v-for="appt in emergencyRoomEncounters" :key="appt._id">
              </er-appointment-details-card>
            </div>
            <!-- <queue-svg id="queue-svg"></queue-svg> -->
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="emergencyRoomEncounters && emergencyRoomEncounters.length > 0" style="position: fixed;bottom: 4em;">
            <n-button type="primary" round size="lg" @click.native="goToCreateEmergencyTriagingPage()">
              <i class="fa fa-plus pr-1"></i>
              {{ $t("message.New Encounter") }}
            </n-button>
          </div>
        </div>
        <n-button v-if="!emergencyRoomEncounters || emergencyRoomEncounters.length == 0" type="primary" round size="lg" style="top: auto;top: 50%;left: 50%;transform:translate(-50%);position: fixed;" @click.native="goToCreateEmergencyTriagingPage()">
          <i class="fa fa-plus pr-1"></i>
          {{ $t("message.New Encounter") }}
        </n-button>
      </tab-pane>

      <tab-pane label="icu-tab">
        <template slot="label">
          <i class="fas fa-procedures" @click="
            $store.commit('setState', {
              stateName: 'homePageActiveTab',
              stateValue: 'icu-tab',
            })
            "></i>
        </template>
        <div style="height: 100%">
          <div class="col-lg-12 col-md-12 col-sm-12" v-if="icuLocation" @click="viewIcuWard()">
            <card class="card-stats rounded">
              <div class="statistics statistics-horizontal">
                <div class="info info-horizontal">
                  <div class="row visit-details details">
                    <div class="col-3 col-md-4 pr-0" style="display: flex;align-items: center;font-size: 3em;color:var(--color-primary);font-weight: 600;">
                      <i class="fas fa-hospital-alt"></i>
                    </div>
                    <div class="col-9 col-md-8 right" style="display: flex;align-items: center;font-size: 1.5em;font-weight: 600;">
                      {{ icuLocation.name }}
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>

          <div v-if="icuBeds && icuBeds.length > 0" class="pb-4">
            <div class="col-lg-12 col-md-12 col-sm-12" v-for="bed in icuBeds" :key="bed._id">
              <card class="card-stats rounded" @click.native="viewIcuBed(bed._id)">
                <div class="statistics statistics-horizontal">
                  <div class="info info-horizontal">

                    <div class="row appointment-id" style="display: flex;justify-content: space-between;margin-bottom: 1em;">
                      <div class="pl-4">
                        <i class="fas fa-procedures" style="font-size: 1.3em;color:var(--color-primary);"></i>
                      </div>
                      <div class="pr-4" style="font-size: small; font-weight: 600;">
                        <span>{{ bed.name }}</span>
                      </div>
                    </div>

                    <div class="row visit-details details">
                      <div class="col-3 col-md-4 pr-0">
                        <div class="row">
                          <div class="col-12 text-center">
                            <img :src="avatarImage" class="picture-src" style="
                                      width: 100px;
                                      border-radius: 50%;
                                      outline-color: transparent;
                                    " />
                            <br />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-center">
                            <div v-if="bed.patient.gender == 'male'" style="color: rgb(33, 150, 243)">
                              <span>
                                <i class="fa fa-mars"></i>
                              </span>
                            </div>
                            <div v-if="bed.patient.gender == 'female'
                              " style="color: rgb(235, 63, 157)">
                              <span>
                                <i class="fa fa-venus"></i>
                              </span>
                            </div>
                            <div v-if="bed.patient.gender == 'others'
                              " style="color: rgb(33, 243, 208)">
                              <span>
                                <i class="fa fa-transgender-alt"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-9 col-md-8 right">
                        <slot>

                          <div class="row" v-if="bed.patient && bed.patient.firstName">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-user"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{ bed.patient.firstName }}
                                {{ bed.patient.lastName }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="bed.patient && bed.patient.patientId">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-info-circle"></i>
                              </span>
                            </div>
                            <div class="col-md-10 col-9 pl-0">
                              <span>{{
                                bed.patient.patientId
                              }}</span>
                            </div>
                          </div>
                          <div class="row" v-if="bed.patient && bed.patient.dob">
                            <div class="col-md-1 col-3 text-center">
                              <span>
                                <i class="fa fa-birthday-cake"></i>
                              </span>
                            </div>
                            <div class="col-md-8 col-9 pl-0">
                              <span>{{
                                getAge(bed.patient.dob)
                              }}</span>
                            </div>
                          </div>

                        </slot>
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>

          <div v-else style="text-align: center;">
            <i class="fa fa-info-circle"></i>
            No icu beds found.
          </div>
        </div>
      </tab-pane>

    </tabs>
    <call-notification v-if="callNotification" :caller="caller" :callType="'incoming'" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()">
    </call-notification>

    <need-help-modal></need-help-modal>
  </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-console */
import AppointmentInProgress from "../components/svg_images/AppointmentInProgress.vue";
import avatarImage from "@/assets/img/proAvatar.png";
import { TabPane, Tabs, Collapse, CollapseItem, Modal } from "src/components";
import {
  StatsCard,
  Switch,
  TimeLine,
  TimeLineItem,
  Table as NTable,
  Checkbox,
} from "src/components";
import { DatePicker } from "element-ui";
import { CoolSelect } from "vue-cool-select";
import { Carousel, Slide } from "vue-carousel";
import CallNotification from "../../../components/CallNotification";
import Message from "src/pages/carenation/Message.vue";
import socket from "@/services/socket";
import AppointmentCard from "../../../pages/carenation/components/AppointmentCard.vue";
import NeedHelpModal from "../components/NeedHelpModal";
import PatientCard from "../components/PatientCard";
import { mapActions } from "vuex";
import ConsentService from "../../../services/consent";
import ErAppointmentDetailsCard from "../../../pages/carenation/components/ErAppointmentDetailsCard.vue";
import AppCameraScanner from "../components/AppCameraScanner.vue";

//svg images
import BookingSvg from "../components/svg_images/BookingSvg.vue";
import QueueSvg from "../components/svg_images/QueueSvg.vue";
import SearchSvg from "../components/svg_images/SearchSvg.vue";
import LabOrderSvg from "../components/svg_images/LabOrderSvg.vue";
import endpointsStore from "../../../store/modules/endpoints.store";

export default {
  name: "nurse-home",

  components: {
    AppointmentInProgress,
    TabPane,
    Tabs,
    Collapse,
    CollapseItem,
    StatsCard,
    [Switch.name]: Switch,
    TimeLine,
    TimeLineItem,
    NTable,
    Checkbox,
    [DatePicker.name]: DatePicker,
    Message,
    Modal,
    CoolSelect,
    Carousel,
    Slide,
    AppointmentCard,
    PatientCard,
    CallNotification,
    BookingSvg,
    QueueSvg,
    SearchSvg,
    LabOrderSvg,
    NeedHelpModal,
    ErAppointmentDetailsCard,
    AppCameraScanner,
  },

  data() {
    return {
      avatarImage,
      signaturePadOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      POSTPONED_APPOINTMENTS: false,
      searchText: "",
      nurseCallingRequests: [],
      patients: [],
      nurseCallingRequestsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      appointments: [],
      laborders: [],
      completedApptDateFilter: new Date(),
      completedApptsPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 3,
      },
      completedAppointments: [],
      scheduledApptDateFilter: new Date(),
      scheduledAppointments: [],
      scheduledApptsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      SHOW_CONSENT_MODAL: false,
      appointment: null,
      labordersPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
      latestStatusQuery: "Report Uploaded",
      labOrderSearchText: "",
      getlaborderExecuting: false,
      loader: null,
      getCompletedAppointmentsExecuting: true,
      incomingCallAppt: {},
      caller: {},
      remoteUser: null,
      callNotification: false,
      participants: [],
      // triaging
      emergencyTriages: [],
      discussionAppointments: [],
      emergencyRoomEncounters: [],
      SHOW_CAPTURE_MODAL: false,
      SHOW_SLOT_SELECTION: false,
      doctorForSlotSelection: null,
      appointmentToReschedule: null,
      latestERStatusQuery: "",

      // appointments filtering
      scheduledApptDoctorFilter: null,
      scheduledApptPatientFilter: null,
      SHOW_DOCTOR_FILTER_MODAL: false,
      SHOW_PATIENT_FILTER_MODAL: false,
      searchedDoctorsForScheduledApptFilter: [],
      searchedPatientsForScheduledApptFilter: [],
      doctorFilterSearchTextScheduledAppts: "",
      patientFilterSearchTextScheduledAppts: "",
      // icu-monitoring
      icuBeds: [],
      icuLocation: null,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
    settings() {
      return this.$store.state.settings;
    },
    activeTab() {
      return this.$store.state.homePageActiveTab;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    IS_DISCLAIMER_ENABLED() {
      return (
        this.endpoint.disclaimer &&
        this.endpoint.disclaimer.enabled &&
        this.settings.disclaimer &&
        this.settings.disclaimer.enabled
      );
    },
    FCMpayload() {
      return this.$store.state.FCMpayload;
    },
  },

  methods: {
    viewIcuBed(bedId) {
      this.$router.push({ path: "icubed/view/:" + bedId });
    },
    viewIcuWard() {
      this.$store.commit("setState", {
        stateName: "icuLocation",
        stateValue: this.icuLocation,
      });
      this.$router.push({ path: "icuward" });
    },
    async getICUbeds() {
      try {
        let res = await this.$store.dispatch(
          "getWardsForUserByNurseGroup",
          this.user._id
        );

        let beds = (
          await this.$store.dispatch("getChildLocations", res.data[0]._id)
        ).children;

        if (res.data[0]._id && res.data[0].name) {
          this.icuLocation = {
            _id: res.data[0]._id,
            name: res.data[0].name,
          };
        }

        this.icuBeds = [];
        for (let i = 0; i < beds.length; i++) {
          // socket.emit('joinRoom', { type: 'patientadmissions', id: $scope.beds[i]._id + '_patientadmissions' })
          if (beds[i].status == "Busy") {
            await this.handleBedAdmission(beds[i]);
            this.icuBeds.push(beds[i]);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async handleBedAdmission(bed) {
      // socket.emit('joinRoom', { type: 'icudata', id: bed._id + '_icudata' })
      let patientAdmission = (
        await this.$store.dispatch("getPatientAddmissions", {
          locationId: bed._id,
          latestStatus: "Admitted",
        })
      ).data[0];

      if (patientAdmission) {
        bed.patient = await this.$store.dispatch(
          "getPatientByPatientId",
          patientAdmission.patientId
        );
      }
    },

    goToPatientManagementTab(patientId) {
      this.$store.commit("setState", {
        stateName: "homePageActiveTab",
        stateValue: "patient-management",
      });

      this.searchText = patientId;
      this.searchPatient();
    },
    // ----------------------- scheduled appts fitlers fuctionality
    openDoctorFilterModal() {
      this.SHOW_DOCTOR_FILTER_MODAL = true;
    },

    async searchDoctorsForScheduledApptsFilter() {
      if (this.doctorFilterSearchTextScheduledAppts) {
        this.searchedDoctorsForScheduledApptFilter = (
          await this.$store.dispatch("searchDoctors", {
            searchString: this.doctorFilterSearchTextScheduledAppts,
          })
        ).data;
      }
    },

    selectDoctorForScheduledApptsFilter(doctor) {
      // console.log("doc selected : ", doctor);
      this.scheduledApptDoctorFilter = doctor;
      this.SHOW_DOCTOR_FILTER_MODAL = false;
      this.applyFiltersForScheduledAppts();
    },

    openPatientFilterModal() {
      this.SHOW_PATIENT_FILTER_MODAL = true;
    },

    async searchPatientsForScheduledApptsFilter() {
      if (this.patientFilterSearchTextScheduledAppts) {
        try {
          this.searchedPatientsForScheduledApptFilter =
            await this.$store.dispatch("searchPatients", {
              query: this.patientFilterSearchTextScheduledAppts,
            });
        } catch (error) {
          console.log(error);
        }
      }
    },

    selectPatientForScheduledApptsFilter(patient) {
      this.scheduledApptPatientFilter = patient;
      this.SHOW_PATIENT_FILTER_MODAL = false;
      this.applyFiltersForScheduledAppts();
    },

    applyFiltersForScheduledAppts() {
      this.getScheduledAppts();
    },

    clearDoctorFiltersForScheduledAppts() {
      this.scheduledApptDoctorFilter = null;
      this.applyFiltersForScheduledAppts();
    },

    clearPatientFiltersForScheduledAppts() {
      this.scheduledApptPatientFilter = null;
      this.applyFiltersForScheduledAppts();
    },

    // ----------------------- end of scheduled appts fitlers fuctionality
    goToCreateEmergencyTriagingPage() {
      console.log("going to triaging page ");
      this.$router.push({ path: "/emergencyTriaging/create" });
    },
    async checkCredits() {
      let userDetails = await this.$store.dispatch(
        "getUserDetails",
        this.user._id
      );
      let minLimit = 0;
      if (
        this.settings.customCreditsLimit &&
        this.settings.customCreditsLimit.enabled &&
        this.settings.customCreditsLimit.discussion.enabled
      ) {
        minLimit = this.settings.customCreditsLimit.minLimit;
      } else {
        return true;
      }
      // minLimit should be greater than minLimit
      if (minLimit >= userDetails.credits) {
        return false;
      } else {
        return true;
      }
    },
    idNotFound() {
      if (this.SHOW_CAPTURE_MODAL) {
        this.SHOW_CAPTURE_MODAL = false;
        swal.fire({
          type: "error",
          title: "Error",
          text: "Id number not found!",
        });
      }
    },
    idFound(id) {
      this.SHOW_CAPTURE_MODAL = false;
      console.log(id);
      this.searchText = id;
      this.searchPatient();
    },
    initiatePayment(appointment) {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          text: "credit points will be deducted", //
          confirmButtonText: this.$t("message.Confirm"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.Cancel"),
        })
        .then(async (result) => {
          if (result && result.value) {
            this.payThroughCredits(appointment);
          }
        });
    },
    async payThroughCredits(appointment) {
      let loader = this.$loading.show();
      try {
        let transaction = await this.$store.dispatch("payUingCredits", {
          gateway: "creditPoints",
          appointmentId: appointment._id,
        });
        if (
          transaction &&
          transaction.latestStatus &&
          transaction.latestStatus == "Success"
        ) {
          swal.fire({
            type: "success",
            title: this.$t("message.Payment successful!"),
            timer: 3000,
          });
          appointment.billingDetails.paid = true;
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Payment failed!"),
            text: this.$t("message.Check credit balance"),
            timer: 5000,
          });
        }
        loader.hide();
      } catch (e) {
        console.log(e);
        loader.hide();
        swal.fire({
          type: "error",
          title: this.$t("message.Payment failed!"),
          timer: 5000,
        });
      }
    },
    goToCreateAppointmentPage() {
      if (this.user.endpoint) {
        this.$router.push({ path: "/appointments/create" });
      } else {
        swal.fire({
          type: "error",
          title: this.$t("message.Endpoint not configured"),
          text: this.$t("message.Contact Administrator"),
          timer: 5000,
        });
      }
    },

    async goToCreateQuickDiscussionPage() {
      let creditsAvailable = await this.checkCredits();
      if (creditsAvailable) {
        if (this.user.endpoint) {
          this.$router.push({ path: "/appointments/quickdiscussion/create" });
        } else {
          swal.fire({
            type: "error",
            title: this.$t("message.Endpoint not configured"),
            text: this.$t("message.Contact Administrator"),
            timer: 5000,
          });
        }
      } else {
        swal.fire({
          type: "error",
          title: this.$t("message.Credits too low Please refill"),
          timer: 5000,
        });
      }
    },

    goToCreateScheduledAppointmentPage() {
      if (this.user.endpoint) {
        this.$router.push({
          path: "/appointments/create",
          query: { schedule: true },
        });
      } else {
        swal.fire({
          type: "error",
          title: this.$t("message.Endpoint not configured"),
          text: this.$t("message.Contact Administrator"),
          timer: 5000,
        });
      }
    },

    goToCreateLaborderPage() {
      if (this.user.endpoint) {
        this.$router.push({ path: "/laborders/create" });
      } else {
        swal.fire({
          type: "error",
          title: this.$t("message.Endpoint not configured"),
          text: this.$t("message.Contact Administrator"),
          timer: 5000,
        });
      }
    },

    changePostponedAppointmentValue() {
      this.getCompletedAppointmentsExecuting = true;
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.POSTPONED_APPOINTMENTS = !this.POSTPONED_APPOINTMENTS;
      this.completedAppointments = [];
      this.completedApptsPagination = {
        pageNumber: 1,
        totalPages: 0,
      };
      this.getCompletedAppointments();
    },
    unreadMessagesCount(appointment) {
      if (
        appointment.unreadMessagesCount &&
        appointment.unreadMessagesCount.hasOwnProperty(this.user._id)
      ) {
        return appointment.unreadMessagesCount[this.user._id];
      } else {
        return 0;
      }
    },
    chatMode(appointment) {
      if (
        appointment.consultationType == "telemed-direct" &&
        this.settings.directTelemedicine.consultancyParadigm == "chat"
      ) {
        return true;
      } else if (this.settings.consultancyParadigm == "chat") {
        return true;
      } else {
        return false;
      }
    },
    onTabChange(label) {
      this.changeAppHeaderText(label);
      if (label === "icu-tab") {
        this.getICUbeds();
      }
    },
    ...mapActions([
      "getCompletedAppointmentsForNurse",
      "getScheduledAppointments",
      "updateAttendant",
      "updateStatusOnJoin",
      "updateStatus",
      "updateAppointment",
    ]),
    initSocket() {
      console.log("Nurse Home - initSocket");
      //Joining socket to be extra sure
      //Join Appointment and Speciality Room
      socket.emit("joinRoom", {
        type: "user",
        id: this.user._id,
        deviceToken: localStorage.firebaseToken,
      });

      this.user.nursegroups.forEach((nursegroupId) => {
        socket.emit("joinRoom", {
          type: "nursegroup",
          id: nursegroupId,
          userId: this.user._id,
        });
      });
    },

    //Nurse calling
    async getNurseCallingRequests() {
      this.nurseCallingRequests = [];
      if (
        this.settings &&
        this.settings.nurseCalling &&
        this.settings.nurseCalling.enabled &&
        this.user.nursegroups &&
        this.user.nursegroups.length > 0
      ) {
        for (var i in this.user.nursegroups) {
          let response = await this.$store.dispatch("getNurseCallingRequests", {
            nursegeoupId: this.user.nursegroups[i],
            pageNumber: this.nurseCallingRequestsPagination.pageNumber,
          });

          let requests = response.data;
          this.nurseCallingRequests =
            this.nurseCallingRequests.concat(requests);
        }
      }
    },
    acceptNurseCallingRequest(nurseCallingRequest) {
      if (nurseCallingRequest.latestStatus == "InProgress") {
        swal
          .fire({
            title: this.$t("message.Marking this request as Completed"),
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            closeOnConfirm: true,
          })
          .then(async (confirm) => {
            if (confirm.value) {
              await this.$store.dispatch(
                "completeNurseCallingRequest",
                nurseCallingRequest._id
              );

              socket.emit("nurseCallingUpdate", {
                nursegroupId: nurseCallingRequest.nursegroup,
                userId: this.user._id,
              });

              swal.fire({
                type: "success",
                title: this.$t("message.Service request completed"),
                timer: 3000,
              });

              this.getNurseCallingRequests();
            }
          });
      } else {
        swal
          .fire({
            title: this.$t(
              "message.You will be accepting this service resquest"
            ),
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            closeOnConfirm: true,
          })
          .then(async (confirm) => {
            if (confirm.value) {
              let response = await this.$store.dispatch(
                "acceptNurseCallingRequest",
                {
                  nurseCallingRequest,
                  userId: this.user._id,
                }
              );

              if (response) {
                swal.fire({
                  type: "success",
                  title: this.$t("message.Request accepted successfully!"),
                  timer: 3000,
                });

                socket.emit("nurseCallingUpdate", {
                  nursegroupId: nurseCallingRequest.nursegroup,
                  userId: this.user._id,
                });

                this.getNurseCallingRequests();
              } else {
                swal.fire({
                  type: "warning",
                  title: this.$t("message.Could not accept the request"),
                  timer: 3000,
                });
              }
            }
          });
      }
    },

    clearSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.searchText = "";
        /*         this.$store.dispatch("getPatientsPaginated", {
          sort: "descending",
          pageNo: 0,
          limit: 10,
        }); */
        this.patients = [];
      }
    },
    clearlabOrderSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.labOrderSearchText = "";
      }
    },

    async searchPatient() {
      if (this.searchText.length > 0) {
        try {
          let res = await this.$store.dispatch("searchPatients", {
            query: this.searchText,
          });
          if (this.searchText.length > 0) {
            this.patients = res;
          } else {
            this.patients = [];
          }
        } catch (e) {
          this.patients = [];
          console.log(e);
          swal.fire(this.$t("message.Error getting patients"));
        }
      } else {
        this.patients = [];
      }
    },
    async getAppointments() {
      try {
        this.appointments = await this.$store.dispatch(
          "getNurseAppointmentsByEndpoint",
          this.endpoint.name
        );
      } catch (e) {
        console.log(e);
      }
    },

    async getErEncounters() {
      try {
        if (this.latestERStatusQuery) {
          this.filterErEncounters();
        } else {
          this.emergencyRoomEncounters = await this.$store.dispatch(
            "getNurseErEncountersByEndpoint",
            this.endpoint.name
          );
        }
      } catch (e) {
        console.log(e);
      }
    },

    async filterErEncounters() {
      try {
        let filter = {
          endpoint: this.endpoint.name,
          latestStatus: this.latestERStatusQuery,
        };
        this.emergencyRoomEncounters = await this.$store.dispatch(
          "filterNurseErEncountersByEndpoint",
          filter
        );
      } catch (e) {
        console.log(e);
      }
    },

    async getDiscussionAppointments() {
      try {
        this.discussionAppointments = await this.$store.dispatch(
          "getNurseDiscussionAppointmentsByEndpoint",
          this.endpoint.name
        );
        this.$forceUpdate();
      } catch (e) {
        console.log(e);
      }
    },

    async getLabOrders($state) {
      try {
        if (!this.getlaborderExecuting) {
          this.getlaborderExecuting = true;
          if (!$state) {
            this.laborders = [];
            this.labordersPagination = {
              pageNumber: 1,
              totalPages: 0,
              pageSize: 3,
            };
          }
          let query = { createdUser: this.user._id };
          if (this.latestStatusQuery) {
            query["latestStatus"] = this.latestStatusQuery;
          }
          if (this.labOrderSearchText) {
            query["patient"] = this.labOrderSearchText;
          }
          let response = await this.$store.dispatch("getLabOrders", {
            pageNumber: this.labordersPagination.pageNumber,
            query: query,
          });

          if (response.data && response.data.length) {
            //Fix for duplicate cards when patient search is cleared
            response.data.forEach((data) => {
              let exists = this.laborders.some((laborder) => {
                return laborder._id == data._id;
              });
              if (!exists) {
                this.laborders.push(data);
              }
            });
            // this.laborders.push(...response.data);
            this.labordersPagination.totalPages = response.totalPages;
            this.labordersPagination.pageNumber += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
          this.getlaborderExecuting = false;
        }
      } catch (e) {
        this.laborders = [];
        console.log(e);
      }
    },
    getConsultationType(consultationType, appointmentType) {
      let label =
        consultationType == "inperson"
          ? this.$t("message.InPerson")
          : this.$t("message.Telemedicine");

      if (appointmentType && appointmentType == "Discussion") {
        return (label = label + " (" + this.$t("message.Discussion") + ")");
      } else {
        return label;
      }
    },
    async checkEndpointStatus() {
      let ep = await this.$store.dispatch(
        "getEndpoint",
        this.user.endpoint.name
      );
      return ep.status;
    },
    async joinAppointment(appointment) {
      let endponitStatus = await this.checkEndpointStatus();
      // endponitStatus = "Busy";
      if (endponitStatus == "Busy") {
        // show ep is busy
        swal.fire({
          title: this.$t("message.Endpoint Busy"),
          type: "info",
          closeOnConfirm: true,
        });
      } else {
        let appt = appointment;
        let res = await this.$store.dispatch("getAppointment", appt._id);
        if (res && res._id) {
          if (
            res.latestStatus != "Completed" &&
            res.latestStatus != "Postponed"
          ) {
            //Update status if not assigned already
            if (!(appointment.latestStatus == "Assigned")) {
              appt = await this.updateStatusOnJoin({
                appointmentId: appointment._id,
              });
            }

            this.$store.commit("setState", {
              stateName: "appointment",
              stateValue: appt,
            });
            this.$router.push({ path: "/telemed" });
          } else {
            swal.fire({
              type: "error",
              title: this.$t("message.Appointment is order already completed"),
              timer: 5000,
            });
            this.getAppointments();
            this.getCompletedAppointments();
            this.getScheduledAppts();
          }
        }
      }
    },
    async joinDiscussionAppointment(appointment) {
      let endponitStatus = await this.checkEndpointStatus();
      // endponitStatus = "Busy";
      if (endponitStatus == "Busy") {
        // show ep is busy
        swal.fire({
          title: this.$t("message.Endpoint Busy"),
          type: "info",
          closeOnConfirm: true,
        });
      } else {
        let appt = appointment;
        let res = await this.$store.dispatch("getAppointment", appt._id);
        if (res && res._id) {
          if (
            res.latestStatus != "Completed" &&
            res.latestStatus != "Postponed"
          ) {
            //Update status if not assigned already
            if (!(appointment.latestStatus == "Assigned")) {
              appt = await this.updateStatusOnJoin({
                appointmentId: appointment._id,
              });
            }

            this.$store.commit("setState", {
              stateName: "appointment",
              stateValue: appt,
            });
            this.$router.push({ path: "/telemeddiscussion" });
          } else {
            swal.fire({
              type: "error",
              title: this.$t("message.Appointment is order already completed"),
              timer: 5000,
            });
            this.getAppointments();
            this.getCompletedAppointments();
            this.getScheduledAppts();
          }
        }
      }
    },
    async joinScheduledAppointment(appointment) {
      try {
        var attendant = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          username: this.user.username,
        };

        //Update attendant who is taking the appointment
        await this.updateAttendant({
          appointmentId: appointment._id,
          attendant: attendant,
        });

        //Update status
        let appt = await this.updateStatusOnJoin({
          appointmentId: appointment._id,
        });

        this.$store.commit("setState", {
          stateName: "appointment",
          stateValue: appt,
        });
        //Redirect to telemedicine page
        this.$router.push({ path: "/telemed" });
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "warning",
          text: this.$t("message.Could not join the appointment"),
        });
      }
    },
    cancelAppointment(appointment) {
      swal
        .fire({
          title: this.$t("message.Are you sure?"),
          text: this.$t("message.You will not be able to undo this action!"),
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: this.$t("message.Yes, cancel it!"),
          closeOnConfirm: true,
          cancelButtonText: "No",
        })
        .then(async (isConfirm) => {
          if (isConfirm && isConfirm.value) {
            //Updating appointment status
            try {
              await this.$store.dispatch("updateStatus", {
                appointmentId: appointment._id,
                status: "Cancelled",
              });
              if (appointment.consultationType != "checkup") {
                if (appointment.provider) {
                  socket.emit("appointmentListUpdate", {
                    providerId: appointment.provider.providerId,
                    specialityId: appointment.specialityId,
                  });
                } else {
                  socket.emit("appointmentListUpdate", {
                    specialityId: appointment.specialityId,
                  });
                }
              }
              this.getAppointments();
              this.getCompletedAppointments();
              this.getScheduledAppts();
              this.getDiscussionAppointments();
              try {
                let provider = await this.$store.dispatch(
                  "getUserById",
                  appointment.provider.providerId
                );
                for (let associate of provider.associations) {
                  if (associate.associationType == "assistant") {
                    socket.emit("appointmentListUpdate", {
                      assistantId: associate.associatedUser,
                    });
                  }
                }
              } catch (e) {
                console.log(e);
              }
            } catch (e) {
              console.log(e);
              swal.fire({
                type: "warning",
                text: this.$t("message.Could not cancel the appointment!"),
                timer: 2000,
              });
            }
          }
        });
    },
    async getCompletedAppointments($state) {
      try {
        this.getCompletedAppointmentsExecuting = true;
        if (!$state) {
          this.completedAppointments = [];
          this.completedApptsPagination = {
            pageNumber: 1,
            totalPages: 0,
            pageSize: 3,
          };
        }
        let response = await this.getCompletedAppointmentsForNurse({
          endpoint: this.endpoint.name,
          dateStart: moment(this.completedApptDateFilter.getTime())
            .startOf("day")
            .valueOf(),
          dateEnd: moment(this.completedApptDateFilter.getTime())
            .endOf("day")
            .valueOf(),
          pageNumber: this.completedApptsPagination.pageNumber,
          pageSize: this.completedApptsPagination.pageSize,
          POSTPONED_APPOINTMENTS: this.POSTPONED_APPOINTMENTS,
        });

        if (response.data && response.data.length) {
          this.completedAppointments.push(...response.data);
          this.completedApptsPagination.totalPages = response.totalPages;
          this.completedApptsPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
        if (this.loader) {
          this.loader.hide();
          this.loader = null;
        }
        this.getCompletedAppointmentsExecuting = false;
      } catch (e) {
        if (this.loader) {
          this.loader.hide();
          this.loader = null;
        }
        this.getCompletedAppointmentsExecuting = false;
        console.log(e);
      }
    },
    getAppointmentDatetime(timestamp) {
      return moment(Number(timestamp)).format("hh:mm a");
    },
    getLaborderDatetime(date) {
      let timestamp = Date.parse(date);
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm a");
    },
    getLabOrderStatus(status) {
      let msgVal = status;
      if (status == "Created") {
        msgVal = this.$t("message.Created");
      }
      if (status == "Accepted") {
        msgVal = this.$t("message.Accepted");
      }
      if (status == "Sample Collected") {
        msgVal = this.$t("message.Sample collected");
      }
      if (status == "Sample Deposited") {
        msgVal = this.$t("message.Sample deposited");
      }
      if (status == "Report Uploaded") {
        msgVal = this.$t("message.Report uploaded");
      }
      return msgVal;
    },
    viewAppointmentDetails(appointment) {
      this.$store.commit("setState", {
        stateName: "appointment",
        stateValue: appointment,
      });

      this.$router.push("viewappointmentdetails");
    },
    viewLabOrderDetails(laborder) {
      this.$router.push({ path: "/viewlaborderdetails/" + laborder._id });
    },
    async getScheduledAppts($state) {
      if (!$state) {
        this.scheduledAppointments = [];
        this.scheduledApptsPagination = {
          pageNumber: 1,
          totalPages: 0,
        };
      }

      let filter = {
        dateStart: this.scheduledApptDateFilter
          ? this.scheduledApptDateFilter.setHours(0, 0, 0, 0)
          : null,
        dateEnd: this.scheduledApptDateFilter
          ? this.scheduledApptDateFilter.setHours(23, 59, 59, 0)
          : null,
        endpoint: this.endpoint.name,
        status: ["Created", "InProgress", "Assigned"],
      };

      if (this.scheduledApptPatientFilter) {
        filter.patientId = this.scheduledApptPatientFilter.patientId;
      }

      if (this.scheduledApptDoctorFilter) {
        filter.providerId = this.scheduledApptDoctorFilter._id;
      }

      let response = await this.getScheduledAppointments({
        filter,
        pageNumber: this.scheduledApptsPagination.pageNumber,
        pageSize: 3,
      });

      if (response.data && response.data.length) {
        this.scheduledAppointments.push(...response.data);
        this.scheduledApptsPagination.totalPages = response.totalPages;
        this.scheduledApptsPagination.pageNumber += 1;
        $state && $state.loaded();
      } else {
        $state && $state.complete();
      }
    },
    async deleteAppointment(appointment) {
      try {
        if (appointment.latestStatus != "InProgress") {
          //Confirmation
          swal
            .fire({
              title: this.$t("message.Are you sure?"),
              text: this.$t(
                "message.You will not be able to undo this action!"
              ),
              type: "warning",
              showCancelButton: true,
              cancelButtonText: this.$t("message.CANCEL"),
              confirmButtonColor: "#DD6B55",
              confirmButtonText: this.$t("message.Yes, delete it!"),
              closeOnConfirm: true,
            })
            .then(async (isConfirm) => {
              if (isConfirm && isConfirm.value && appointment) {
                swal.fire({
                  type: "success",
                  text: this.$t("message.Appointment deleted!"),
                  timer: 2000,
                });
                await this.updateStatus({
                  appointmentId: appointment._id,
                  status: "Deleted",
                });

                socket.emit("appointmentDeleted", {
                  providerId: appointment.provider.providerId,
                  appointmentId: appointment._id,
                });

                this.getScheduledAppts();
              }
            });
        } else {
          swal.fire(this.$t("message.Appointment is in progress"));
        }
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "warning",
          text: this.$t("message.Could not join the appointment!"),
          timer: 3000,
        });
      }
    },
    async showConsentIfEnabled(appointment) {
      this.appointment = appointment;
      if (this.IS_DISCLAIMER_ENABLED) {
        //get informed consent
        let response = await this.$store.dispatch("getConfigurationByType", {
          type: "informedConsent",
        });
        if (response && response.value) {
          this.settings.directTelemedicine.informedConsent = response.value;
        }
        this.SHOW_CONSENT_MODAL = true;
      } else {
        this.joinScheduledAppointment(appointment);
      }
    },
    clearSignaturePad() {
      this.$refs.signature.clear();
    },
    async onConsentAgreed() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (!this.$refs.signature.isEmpty()) {
        try {
          this.appointment.consent = {
            signedByOther: false,
            language: "English",
          };

          ConsentService.getDataURL(
            this.$refs.signature.save("image/jpeg"),
            this.settings.directTelemedicine.informedConsent,
            (dataUrl) => {
              fetch(dataUrl).then((res) => {
                res.blob().then(async (consent_blob) => {
                  var d = new Date();
                  var t = d.getTime();

                  try {
                    let response = await this.$store.dispatch(
                      "getPresignedUrl",
                      "consent-" + t + ".pdf"
                    );
                    await this.$store.dispatch("saveFileToMinio", {
                      url: response.url,
                      file: consent_blob,
                    });

                    let fileDetails = {
                      type: "pdf",
                      fileId: response.fileId,
                    };

                    this.appointment.consent.fileID = fileDetails.fileId;
                    let appointment = await this.updateAppointment(
                      this.appointment
                    );
                    loader.hide();
                    swal
                      .fire({
                        type: "success",
                        text: this.$t("message.Taking you to the appointment"),
                        timer: 3000,
                      })
                      .then(() => {
                        this.joinScheduledAppointment(appointment);
                      });
                  } catch {
                    loader.hide();
                    swal.fire({
                      type: "error",
                      title: this.$t("message.Error saving Disclaimer!"),
                      timer: 5000,
                    });
                  }
                });
              });
            }
          );
        } catch (e) {
          loader.hide();
          console.log(e);
          swal.fire({
            type: "error",
            title: this.$t("message.Could not join the appointment!"),
            timer: 5000,
          });
        }
      } else {
        loader.hide();
        swal.fire({
          type: "warning",
          title: this.$t("message.Patient's signature is required!"),
          timer: 3000,
        });
      }
    },
    onCallMissed() {
      this.callNotification = false;
      socket.emit("leaveRoom", {
        type: "appointment",
        id: this.incomingCallAppt._id,
        userId: this.user._id,
      });
    },
    async onCallDeclined() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.incomingCallAppt._id,
        status: "declined",
      });

      if (response && response._id) {
        let message = {
          username: this.user.username,
          status: "declined",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });
        socket.emit("leaveRoom", {
          type: "appointment",
          id: this.incomingCallAppt._id,
          userId: this.user._id,
        });
      }
    },
    async onCallAccepted() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.incomingCallAppt._id,
        status: "accepted",
      });

      if (response && response._id) {
        let message = {
          username: this.user.username,
          status: "accepted",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.incomingCallAppt._id,
          chatMessage: message,
        });

        if (this.incomingCallAppt.appointmentType == "Scheduled") {
          this.joinScheduledAppointment(this.incomingCallAppt);
        } else if (this.incomingCallAppt.appointmentType == "Live") {
          this.joinAppointment(this.incomingCallAppt);
        }
      }
    },
    async onCallPushNotification(payload, join) {
      let that = this;
      that.participants = [];
      that.incomingCallAppt = await that.$store.dispatch(
        "getAppointment",
        payload.appointmentId
      );
      for (let i = that.incomingCallAppt.chatMessages.length - 1; i >= 0; i--) {
        if (
          that.incomingCallAppt.chatMessages[i].content &&
          that.incomingCallAppt.chatMessages[i].content == "Video call"
        ) {
          if (that.incomingCallAppt.chatMessages[i].status == "initiated") {
            let doctorDisplayPic = that.avatarImage;
            let doctor = await that.$store.dispatch(
              "getUserById",
              that.incomingCallAppt.provider.providerId
            );
            if (doctor.profileImage) {
              doctorDisplayPic = `${that.$store.state.baseUrl}/file/${doctor.profileImage}`;
            }
            /*             that.remoteUser = {
              id: that.incomingCallAppt.provider.username,
              name:
                that.incomingCallAppt.provider.firstName +
                " " +
                that.incomingCallAppt.provider.lastName,
              imageUrl: doctorDisplayPic,
            }; */

            that.participants.push({
              id: that.incomingCallAppt.provider.username,
              name:
                that.incomingCallAppt.provider.firstName +
                " " +
                that.incomingCallAppt.provider.lastName,
              imageUrl: doctorDisplayPic,
            });

            for (let associate of doctor.associations) {
              if (associate.associationType == "assistant") {
                that.participants.push({
                  id: associate.associatedUserUserName,
                  name: associate.associatedUserFullName,
                  imageUrl: associate.associatedUserProfileImage
                    ? `${that.$store.state.baseUrl}/file/${associate.associatedUserProfileImage}`
                    : that.avatarImage,
                });
              }
            }
            console.log(that.participants);
            for (let participant of that.participants) {
              if (
                participant.id == that.incomingCallAppt.chatMessages[i].username
              ) {
                that.remoteUser = participant;
              }
            }
            console.log(that.remoteUser);
            that.caller.img = that.remoteUser.imageUrl;
            that.caller.name = that.remoteUser.name;
            that.callNotification = true;

            socket.emit("joinRoom", {
              type: "appointment",
              id: that.incomingCallAppt._id,
              userId: that.user._id,
            });
          } else {
            if (join) {
              if (that.incomingCallAppt.appointmentType == "Scheduled") {
                that.joinScheduledAppointment(that.incomingCallAppt);
              } else if (that.incomingCallAppt.appointmentType == "Live") {
                that.joinAppointment(that.incomingCallAppt);
              }
            }
          }
          break;
        }
      }
    },
    openSlotSelection(appt) {
      this.doctorForSlotSelection = appt.provider;
      this.appointmentToReschedule = appt;
      this.SHOW_SLOT_SELECTION = true;
    },
    onSlotSelected(slot) {
      swal
        .fire({
          title: this.$t(
            "message.Are you sure that you want to reschedule this appointment?"
          ),
          type: "info",
          confirmButtonText: this.$t("message.Yes"),
          showCancelButton: true,
          cancelButtonText: this.$t("message.No"),
        })
        .then(async (result) => {
          if (result && result.value) {
            try {
              this.appointmentToReschedule.scheduledTimestamp = {
                start: slot.start,
                end: slot.end,
              };
              await this.$store.dispatch(
                "updateAppointment",
                this.appointmentToReschedule
              );
              this.SHOW_SLOT_SELECTION = false;
              swal.fire({
                type: "success",
                title: this.$t("message.Appointment rescheduled!"),
                timer: 3000,
              });
              this.getScheduledAppts();
            } catch (e) {
              this.SHOW_SLOT_SELECTION = false;
              console.log(e);
              swal.fire({
                type: "error",
                title: this.$t(
                  "message.Error, couldn't reschedule the appointment!"
                ),
                timer: 3000,
              });
            }
          }
        });
    },
  },

  async mounted() {
    let that = this;

    if (this.user) {
      await this.$store.dispatch("getUserDetails", this.user._id);

      this.$root.onBackButton = () => {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        } else {
          console.log("user menu is closed, showing swal ...");
          let that = this;
          swal
            .fire({
              title: that.$t("message.Are you sure?"),
              confirmButtonText: that.$t("message.Exit"),
              showCancelButton: true,
              cancelButtonText: that.$t("message.Stay"),
            })
            .then(async (result) => {
              if (result && result.value) {
                navigator.app.exitApp();
              }
            });
        }
      };
      // available tabs
      let tabs = [
        {
          name: "waitingRoom",
          id: "waiting-room",
        },
        {
          name: "scheduledAppointments",
          id: "scheduled-appts",
        },
        {
          name: "completedAppointments",
          id: "completed-appts",
        },
        {
          name: "patientManagement",
          id: "patient-management",
        },
        {
          name: "nurseCalling",
          id: "nurse-calling",
        },
        {
          name: "labOrders",
          id: "lab-orders",
        },
      ];
      // set first enabled tab as active
      if (this.activeTab) {
        this.changeAppHeaderText(this.activeTab);
      } else {
        for (let i = 0; i < tabs.length; i++) {
          const tab = tabs[i];
          if (
            tab.name == "nurseCalling" &&
            this.settings &&
            this.settings.nurseCalling &&
            this.settings.nurseCalling.enabled
          ) {
            this.$store.commit("setState", {
              stateName: "homePageActiveTab",
              stateValue: tab.id,
            });
            this.changeAppHeaderText(tab.id);
            break;
          }
          if (this.user.tabsEnabled[tab.name]) {
            this.$store.commit("setState", {
              stateName: "homePageActiveTab",
              stateValue: tab.id,
            });
            this.changeAppHeaderText(tab.id);
            break;
          }
        }
      }
      await this.$store.dispatch("getSettings");
      await this.$store.dispatch(
        "getEndpoint",
        this.user.endpoint.name || this.user.endpoint
      );

      this.latestERStatusQuery = this.$store.state.latestERStatusQuery;

      this.getNurseCallingRequests();
      this.getAppointments();
      this.getDiscussionAppointments();
      this.getCompletedAppointments();
      this.getScheduledAppts();
      this.getLabOrders();
      this.initSocket();
      this.getErEncounters();

      this.getICUbeds();

      window.initSocket = this.initSocket;

      //Socket Events Handler
      socket.on("nurseCallingUpdate", (data) => {
        if (data.userId != this.user._id) {
          this.getNurseCallingRequests();
        }
      });

      socket.on("appointmentListUpdate", async function () {
        that.getAppointments();
        that.getDiscussionAppointments();
      });

      //Subscribing to firebase topics

      for (let index in this.user.nursegroups) {
        try {
          let nursegroup = await this.$store.dispatch(
            "getNursegroup",
            this.user.nursegroups[index]._id || this.user.nursegroups[index]
          );
          cordova.plugins.firebase.messaging.subscribe(
            this.instance + "-" + this.user.tenant.name + "-" + nursegroup.name
          );
        } catch (e) {
          console.log(e);
        }
      }

      if (that.FCMpayload) {
        if (
          that.FCMpayload.type == "callNotification" &&
          that.FCMpayload.appointmentId
        ) {
          that.onCallPushNotification(that.FCMpayload);
        } else if (
          that.FCMpayload.type == "checkedinNotification" &&
          that.FCMpayload.patientId &&
          that.user.tabsEnabled &&
          that.user.tabsEnabled.patientManagement
        ) {
          that.$store.commit("setState", {
            stateName: "homePageActiveTab",
            stateValue: "scheduled-appts",
          });

          try {
            let patientId = that.FCMpayload.patientId;

            let patient = await this.$store.dispatch(
              "getPatientByPatientId",
              patientId
            );

            this.selectPatientForScheduledApptsFilter(patient);
          } catch (e) {
            console.error(e);
          }
        }
        that.$store.state.FCMpayload = null;
      }

      cordova.plugins.firebase.messaging.onMessage(async function (payload) {
        console.log("New foreground FCM message: ", payload);
        if (payload.type == "callNotification" && payload.appointmentId) {
          that.onCallPushNotification(payload);
          that.$store.state.FCMpayload = null;
        }
      });

      cordova.plugins.firebase.messaging.onBackgroundMessage(async function (
        payload
      ) {
        if (payload && payload.type && payload.type == "nurseCallingRequest") {
          this.getNurseCallingRequests();
        }
        if (payload.type == "callNotification" && payload.appointmentId) {
          that.onCallPushNotification(payload, true);
        } else if (
          payload.type == "checkedinNotification" &&
          payload.patientId &&
          that.user.tabsEnabled &&
          that.user.tabsEnabled.patientManagement
        ) {
          that.$store.commit("setState", {
            stateName: "homePageActiveTab",
            stateValue: "scheduled-appts",
          });

          try {
            let patientId = payload.patientId;

            let patient = await that.$store.dispatch(
              "getPatientByPatientId",
              patientId
            );

            that.selectPatientForScheduledApptsFilter(patient);
          } catch (e) {
            console.error(e);
          }
        }
        that.$store.state.FCMpayload = null;
      });

      socket.on("newChatMessage", async (message) => {
        if (message.chatMessage.username != this.user.username) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
            socket.emit("leaveRoom", {
              type: "appointment",
              id: this.incomingCallAppt._id,
              userId: this.user._id,
            });
          }
        }
      });

      window.onAppResume = () => {
        setTimeout(() => {
          that.getNurseCallingRequests();
        }, 0);
      };
      let user = await this.$store.dispatch("getUserById", this.user._id);
      try {
        let userEndpoint = await this.$store.dispatch(
          "getEndpointByDeviceType",
          this.user._id
        );
        if (userEndpoint && userEndpoint._id) {
          user.endpoint = userEndpoint;
        }
      } catch (e) {
        console.log(e);
      }

      localStorage.user = JSON.stringify(user);

      if (localStorage.searchText) {
        this.searchText = localStorage.searchText;
        this.searchPatient();
      }
    } else {
      this.$router.push({ path: "/signin" });
    }

    console.log("active tab is : ", this.activeTab);
  },

  beforeDestroy() {
    this.$root.onBackButton = null;
    socket.off("nurseCallingUpdate");

    window.initSocket = null;
  },

  watch: {
    "nurseCallingRequestsPagination.pageNumber": function () {
      this.getNurseCallingRequests();
    },
    searchText: function (v) {
      localStorage.searchText = v;
    },
    completedApptDateFilter: function () {
      this.getCompletedAppointments();
    },
    scheduledApptDateFilter: function () {
      this.getScheduledAppts();
    },
    latestStatusQuery: function () {
      this.getLabOrders();
    },
    latestERStatusQuery: function () {
      this.$store.commit("setState", {
        stateName: "latestERStatusQuery",
        stateValue: this.latestERStatusQuery,
      });
      this.getErEncounters();
    },
  },
};
</script>

<style scoped>
/deep/.scheduled-appts-date-filter.close-icon
  .el-input__suffix-inner
  > .el-input__icon:before {
  content: "\E78D";
}

/deep/.scheduled-appts-date-filter.close-icon
  .el-input__suffix-inner
  > .el-input__icon {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}

.view-filters-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.filter-modal {
  height: 70vh;
}

.filters-list-wrapper {
  height: 80%;
  overflow-y: scroll;
}

.search-result {
  padding-top: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

#create-scheduled-appt-button {
  top: auto;
  bottom: 50vh;
  position: fixed;
  z-index: 1;
  transform: translate(-50%, -50%);
}

#main-create-appt-button,
#main-create-discussion-button {
  top: auto;
  bottom: 50vh;
  position: fixed;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 16em;
}

#main-create-discussion-button {
  bottom: 40vh;
}

[dir="rtl"] #main-create-appt-button,
[dir="rtl"] #main-create-discussion-button,
[dir="rtl"] #create-scheduled-appt-button {
  transform: translate(50%, -50%);
}

#booking-svg {
  width: 90%;
  height: auto;
  position: fixed;
  bottom: 4em;
  max-height: 50vh;
  transform: translateX(-50%);
}

#queue-svg {
  max-width: 100%;
  height: auto;
  position: fixed;
  bottom: 4em;
  max-height: 50vh;
  transform: translateX(-50%);
}

[dir="rtl"] #queue-svg,
[dir="rtl"] #booking-svg {
  transform: translateX(50%);
}

.search-block {
  width: 100%;
  margin-left: 0px;
  margin-right: 0px;
}

.not-found-img {
  width: 70vw;
}
</style>

<style>
#home .stats {
  text-align: center;
}

.search-block {
  width: 100%;
  background-color: white;
  padding-top: 1em;
  padding-right: 2em;
  padding-left: 2em;
  margin-left: -2em;
  margin-right: -2em;
  padding-bottom: 6px;
}

.not-found-img {
  width: 100%;
}

.card-header-nav {
  background: var(--color-primary);
}

.card-header-nav .nav-pills > li > a > div {
  color: #fff;
}

.card-header-nav .nav-pills.nav-pills-neutral .nav-item .nav-link {
  background-color: transparent !important;
  box-shadow: none;
}

#home .tab-content.tab-subcategories {
  width: 100%;
}

.main-panel > .content {
  margin-top: 0px;
}

.icon .nav-link {
  padding: 0px 15px !important;
}

.tab-no-space {
  padding-top: 0px !important;
}
</style>

<style scoped>
@media screen and (max-width: 412px) {
  /deep/.nav-pills .nav-item .nav-link {
    min-width: 68px;
  }
}

@media screen and (max-width: 380px) {
  /deep/ .btn-round.btn-simple {
    padding: 10px 15px;
  }

  /deep/ .btn-round {
    padding-right: 17px;
    padding-left: 17px;
  }
}

/deep/.nav-pills .nav-item .nav-link {
  min-width: 60px;
}

#care-card-front,
.care-card-description {
  height: 18em;
}

.care-card-description {
  overflow: scroll;
}

.image-text-overlay {
  font-size: 0.7em;
}

.appointments-wrapper {
  margin-top: 1em;
}

.icon.icon-circle {
  width: 65px;
  height: 65px;
  max-width: 65px;
  margin: auto;
  margin-top: 8px;
  border-radius: 30%;
}

.icon.icon-circle i {
  display: table;
  margin: 0 auto;
  line-height: 2.8;
  font-size: 25px;
}

.link-label {
  margin-top: 1em;
  display: block;
}

.link-section {
  margin-top: 0.5em;
  padding-top: 1.5em;
  border-top: 1px solid #dcd7d7;
}

/deep/ .tab-content {
  height: calc(100% - 68px);
  /* for fixed quick acction buttons from bottom */
  position: relative;
}

.content > div {
  height: 100%;
}

.tab-pane.active {
  height: 100%;
  overflow: scroll;
  padding-top: 1em;
}

/deep/.nav-pills.nav-pills:not(.flex-column)
  .nav-item:not(:last-child)
  .nav-link {
  margin-right: 10px;
}

.message-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}

.message-list:first-child {
  border-top: none;
}

.message-list.selected {
  background-color: whitesmoke;
}

.message-icon {
  line-height: 3em;
  color: #2ca8ff;
  font-size: 1.5em;
}

.reason {
  font-size: 1.3em;
  margin-bottom: 2px;
}

.icon.icon-circle img {
  padding: 20px;
}

/deep/ .sc-chat-window {
  max-height: 100%;
  inset-inline-end: 0px;
  bottom: 0px;
  width: 100%;
  height: 78vh;
}

/deep/ .sc-message {
  width: 90%;
}

/deep/ .sc-header {
  display: none;
}

/deep/ .sc-launcher.opened {
  display: none;
}

/deep/ .VueCarousel-dot-container {
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot {
  width: 5px !important;
  height: 5px !important;
  margin-top: 0px !important;
}

/deep/ .VueCarousel-dot:focus {
  outline: none !important;
}

/deep/ #lab-orders .el-select {
  width: 100%;
}

/deep/.card-collapse .card.card-plain {
  margin-bottom: 0;
}

/deep/ #filters-card .card.card-plain a:hover {
  text-decoration: none;
}

/deep/ #filters-card {
  background-color: #80808026;
}

/deep/ #filters-card .card-body {
  padding-top: 0;
  padding-bottom: 0;
}

/deep/ #filters-card .form-control {
  background-color: #fff;
}

.boxes {
  --size: 32px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
}

.boxes .box {
  width: var(--size);
  height: var(--size);
  top: 0;
  left: 0;
  position: absolute;
  transform-style: preserve-3d;
}

.boxes .box:nth-child(1) {
  transform: translate(100%, 0);
  animation: box1 var(--duration) linear infinite;
}

.boxes .box:nth-child(2) {
  transform: translate(0, 100%);
  animation: box2 var(--duration) linear infinite;
}

.boxes .box:nth-child(3) {
  transform: translate(100%, 100%);
  animation: box3 var(--duration) linear infinite;
}

.boxes .box:nth-child(4) {
  transform: translate(200%, 0);
  animation: box4 var(--duration) linear infinite;
}

.boxes .box > div {
  --background: #45b2fe;
  --top: auto;
  --inset-inline-end: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  inset-inline-end: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX))
    translateZ(var(--translateZ));
}

.boxes .box > div:nth-child(1) {
  --top: 0;
  --left: 0;
}

.boxes .box > div:nth-child(2) {
  --background: #369ae0;
  --inset-inline-end: 0;
  --rotateY: 90deg;
}

.boxes .box > div:nth-child(3) {
  --background: #aadcff;
  --rotateX: -90deg;
}

.boxes .box > div:nth-child(4) {
  --background: #dbe3f4;
  --top: 0;
  --left: 0;
  --translateZ: calc(var(--size) * 3 * -1);
}

@keyframes box1 {
  0%,
  50% {
    transform: translate(100%, 0);
  }

  100% {
    transform: translate(200%, 0);
  }
}

@keyframes box2 {
  0% {
    transform: translate(0, 100%);
  }

  50% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(100%, 0);
  }
}

@keyframes box3 {
  0%,
  50% {
    transform: translate(100%, 100%);
  }

  100% {
    transform: translate(0, 100%);
  }
}

@keyframes box4 {
  0% {
    transform: translate(200%, 0);
  }

  50% {
    transform: translate(200%, 100%);
  }

  100% {
    transform: translate(100%, 100%);
  }
}

html {
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: border-box;
}

*:before,
*:after {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  font-family: Roboto, Arial;
  color: #adafb6;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9fbff;
}

body .dribbble {
  position: fixed;
  display: block;
  inset-inline-end: 20px;
  bottom: 20px;
}

body .dribbble img {
  display: block;
  height: 28px;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ .modal-dialog {
  max-width: inherit;
}

@media (min-width: 768px) {
  #care-card-front,
  .care-card-description {
    height: 24em;
  }
}

@media (min-width: 992px) {
  #care-card-front,
  .care-card-description {
    height: 22em;
  }
}

@media (max-height: 667px) {
  #care-card-front,
  .care-card-description {
    height: 11em;
  }
}

@media (min-height: 768px) {
  /deep/ .sc-chat-window {
    height: 74vh;
  }
}

@media (min-height: 1024px) {
  /deep/ .sc-chat-window {
    height: 81vh;
  }
}

.content > div,
.content > div > div {
  height: 100%;
}

/deep/ .scheduled-appointment-card .btn {
  margin: 0.5em;
}

/deep/#icu-tab .card-body {
  padding: 15px;
}
</style>
